export const POSITION_LIST_COMMENT_SUGGESTIONS: string[] = [
  'Rippe in Rähm und Schwelle durchzapfen gemäß Standarddetail',
  'Rähm und Schwelle unterbrechen, Rippe direkt unter darüberliegendes Bauteil (Pfette/Unterzug) stellen, direkt auf darunterliegendem Bauteil auflagern',
]

/**
 * Predefined suggestions for tensile-anchor comments (Anker list). Anchor comments are unrelated
 * to the position-list texts, so they keep their own pool; recently used values are prepended via
 * `withUserCommentSuggestion` (see `anchorCommentSuggestion` in the results store).
 */
export const ANCHOR_COMMENT_SUGGESTIONS: string[] = []

export const PREAMBLE_COMMENT_SUGGESTIONS: string[] = [
  'Geringfügige Überschreitung der Auflagerpressung toleriert.',
  'Geringfügige Überschreitung der Verformung toleriert.',
  'Geringfügige Überschreitung im Querkraftnachweis toleriert, da weitere vorhandene Querschnitte nicht berücksichtigt wurden.',
]

/** Prepend a recently used value when it is not already in the predefined list. */
export const withUserCommentSuggestion = (
  predefined: string[],
  userSuggestion: string,
): string[] => {
  const trimmed = userSuggestion.trim()
  if (!trimmed || predefined.includes(trimmed)) return predefined
  return [trimmed, ...predefined]
}
